//Componentes generales
import React, { useState, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Routes_gral from "../../utils/Routes_gral";
import "react-phone-input-2/lib/style.css";

// Alertas
import Swal from "sweetalert2";

//Imagenes
import logoG4 from "../../images/LOGO-BLANCO.png";

//Estilos
import "./RecoverPassword.css";

//Contexto
import authContext from "../../context/authentication/authContex";
import ReCAPTCHA from "react-google-recaptcha";


function RecoverPassword(props) {
  const aContext = useContext(authContext);
  const { enviarEmailToRecoverPassword } = aContext;

  const navigate = useNavigate();

  const recaptcha = useRef(null);

  const [stepper, setStepper] = useState(1);
  const [userName, setUserName] = useState("");
  const [tenantId, setTenantId] = useState("");

  const alerta = (mensaje, typeIcon) => {
    return Swal.fire({
      text: mensaje,
      icon: typeIcon,
      confirmButtonText: "OK",
    });
  };

  const onSubmit = async () => {
    if (userName.trim() == "") {
      alerta(
        "Debe ingresar un Username",
        "warning"
      );
      return;
    }
    if (tenantId.trim() == "") {
      alerta(
        "Debe ingresar un Alias de Empresa",
        "warning"
      );
      return;
    }

    const captchaToken = recaptcha.current.getValue();
    if (!captchaToken) {
      alerta("Por favor, complete el captcha.", "warning");
      return;
    }

    setStepper(2);
    try {
      await enviarEmailToRecoverPassword(userName,tenantId);
      setStepper(3);
      setUserName("");
      setTenantId("");
      aContext.limpiarError();
    } catch (error) {
      console.log("ERROR EN ENVIAR EMAIL PARA RECUPERAR CONTRASEÑA", error);

      recaptcha.current.reset();

      const mensajeError = String(
        error?.response?.data?.message ||
          error?.response?.data?.msg ||
          error?.message ||
          "Error desconocido."
      );
      alerta(mensajeError, "warning");
      return setStepper(1);
    }
  };

  const onLogin = async () => {
    aContext.limpiarError();
    navigate(Routes_gral.login);
  };

  return (
    <div className="container-registro">
      <div className="card-registro">
        {stepper === 1 ? (
          <>
            <div className="containerRegistroTitulo">
              <h2>Recuperar contraseña</h2>
            </div>
            <div style={{ textAlign: "center" }}>
              <p>
                Ingrese su Username:
              </p>
            </div>
            <div
              className="containerRegistroInput  obligatorio"
              style={{ marginTop: "5px", marginBottom: "20px" }}
            >
              <input
                className="textRegistroInput"
                id="userName"
                placeholder="Username"
                type="text"
                name="userName"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    onSubmit();
                  }
                }}
              />
              <span className="asterisco" style={{ marginTop: "-10px" }}>
                *
              </span>
            </div>
            <div style={{ textAlign: "center" }}>
              <p>
                Ingrese el Alias de Empresa asociado a su cuenta de Xertux
                Mantenimiento:
              </p>
            </div>
            <div
              className="containerRegistroInput  obligatorio"
              style={{ marginTop: "5px", marginBottom: "20px" }}
            >
              <input
                className="textRegistroInput"
                id="tenantId"
                placeholder="Alias de Empresa"
                type="text"
                name="tenantId"
                value={tenantId}
                onChange={(e) => setTenantId(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    onSubmit();
                  }
                }}
              />
              <span className="asterisco" style={{ marginTop: "-10px" }}>
                *
              </span>
            </div>
          <div style={{ marginTop: "10px", marginBottom:"10px" }}>
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_CAPTCHA_KEY}
              ref={recaptcha}
            />
          </div>
            <div className="buttonsStep1Container">
              <button className="btnGoBackStyle" onClick={onLogin}>
                Volver
              </button>
              <button className="btnSubmitStyle" onClick={onSubmit}>
                Enviar email
              </button>
            </div>
          </>
        ) : stepper == 2 ? (
          <>
            <div>
              <header>
                <h4 style={{ color: "black", marginTop: "10px" }}>
                  Enviando email...
                </h4>
              </header>
            </div>
          </>
        ) : stepper === 3 ? (
          <>
            <div style={{ textAlign: "center" }}>
              <h2>Email enviado con éxito!</h2>
              <p>
                Revisa tu casilla de correo y sigue las
                instrucciones para recuperar tu contraseña.
              </p>
              <button id="myBtn" className="btnSubmitStyle" onClick={onLogin}>
                Aceptar
              </button>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
}

export default RecoverPassword;